// Invitation, verify and reset links carry their token in the URL fragment,
// which browsers never send, so it stays out of our request logs. Take it and
// clear it from the address bar at boot, before Sentry or Mixpanel read the URL.
const AUTH_LINK_PATHS = ["/invitations", "/verify", "/reset/confirm"];

const takeToken = (): string | undefined => {
  if (typeof window === "undefined") return;

  const { pathname, hash } = window.location;
  if (!AUTH_LINK_PATHS.includes(pathname) || hash.length <= 1) return;

  window.history.replaceState(window.history.state, "", pathname);
  return decodeURIComponent(hash.slice(1));
};

export const AUTH_LINK_TOKEN = takeToken();
